import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseApiService } from '../../../core/base-api.service';
import { ApiResponse, PageableApiResponse } from '../../api-response';
import { Alert, AlertDeliveryStatus, AlertStatus } from '../models/alert.model';

/** /api/v1/alert — fired/resolved alerts, newest first, paginated (viewer). */
@Injectable({ providedIn: 'root' })
export class AlertService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${this.coreApiUrl}/api/v1/alert`;

  /** `status` null = full history; FIRING = active; RESOLVED = closed. */
  getAlerts(
    status: AlertStatus | null,
    page: number,
    size: number,
  ): Observable<PageableApiResponse<Alert>> {
    let params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    if (status) {
      params = params.set('status', status);
    }
    return this.http.get<PageableApiResponse<Alert>>(this.baseUrl, { params });
  }

  /** Per-channel delivery health; a channel absent from the list has never attempted a delivery. */
  getDeliveryStatuses(): Observable<ApiResponse<AlertDeliveryStatus[]>> {
    return this.http.get<ApiResponse<AlertDeliveryStatus[]>>(`${this.baseUrl}/delivery-status`);
  }
}
